import { SharedActionTypes } from '@Stores/shared/shared.action-types'
import * as Redux from 'redux'

const setClientLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({ type: SharedActionTypes.SET_CLIENT_LOADING, payload })
    }
}

const setPageLoading = (payload: boolean) => {
    return (dispatch: Redux.Dispatch) => {
        dispatch({ type: SharedActionTypes.SET_PAGE_LOADING, payload })
    }
}

const SharedActions = {
    setClientLoading,
    setPageLoading,
}

export default SharedActions
